import {useSoopUiPopupLayer} from '@/components/ui/soop-ui-layer-popup';
import globalDomains from '@/utils/global-domains';

/** SAVYG 숲 AI 영상 콘테스트 배너 */
const SavygContestLayer = ({layerId, onClose}) => {
  const {isCheckedToday, setIsCheckedToday, handleLayerClose} =
    useSoopUiPopupLayer(layerId, onClose);

  return (
    <div className='bnrimg_area'>
      <img
        alt={''}
        src={`${globalDomains.RES_AFREECATV}/images/afmain/bnr_savyg_event.png`}
      />
      <a
        href={`${globalDomains.WWW_AFREECATV}/events/savyg-event/apply`}
        className='link'
        target='_blank'>
        이벤트 페이지 이동
      </a>
      <div className='btn_wrap'>
        <div className='close_days'>
          <input
            type='checkbox'
            id='hideToday'
            checked={isCheckedToday}
            onChange={(e) => setIsCheckedToday(e.target.checked)}
          />
          <label htmlFor='hideToday'>3일간 보지 않음</label>
        </div>
      </div>
      <button
        type='button'
        className='btn_close'
        onClick={() =>
          handleLayerClose({expireDays: 3, expireAtMidnight: false})
        }>
        닫기
      </button>
    </div>
  );
};

export default SavygContestLayer;
